import React from "react";
import { Button } from "antd";
import "./Button.scss";
const ButtonComponent = ({
  text = "Submit",
  htmlType = "button",
  loading = false,
  block = true,
  size = "large",
  className = "",
  onClick,
  type="primary",
  icon=null,
  disabled = false,
}) => {
  let classNames = "primary-button-component " + className;
  if(size === "small") {
    classNames += "primary-button-component btn-small ";
  } else if(size === "large") {
    classNames += "primary-button-component btn-large ";
  } else {
    classNames += "primary-button-component btn-default ";
  }
  
  if(disabled) {
    classNames += " btn-disabled";
  }
  
  return (
    <Button
      type={type}
      htmlType={htmlType}
      loading={loading}
      block={block}
      size={size}
      onClick={onClick}
      className={classNames}
      disabled={disabled}
    >
      {text}
      {icon}
    </Button>
  );
};

export default ButtonComponent;
